<template>
    <div class="pop-over" v-if="show" @click="hide">
        <category-row v-if="head" v-bind:category="head" v-bind:on-toggle="closeRow" v-bind:on-select="closeRow" arrow="down"></category-row>

        <category-row
            v-for="(item) in displayList"
            :key="item._id"
            v-bind:category="item"
            v-bind:on-toggle="openRow"
            v-bind:on-select="select"
            arrow="up"
        ></category-row>
    </div>
</template>

<script>
import api from '@/server'
import * as _ from "lodash";
import categoryRow from "./category-row";

export default {
    name: "CategorySearchPop",

    props: {
        onSelect: Function,
    },

    components: {
        categoryRow
    },

    data() {
        return {
            // 所有的类别
            all: [],

            // <id 类别>
            categoriesMap: new Map(),

            // 显示栈
            stack: [],

            // 是否正在加载
            loading: true,

            // 错误
            error: null,

            show: false,
        }
    },

    async created() {
        await this.init();

        if (this.onSelect && this.all && this.all.length) {
            this.onSelect(this.all[0]); // 默认选中第一个
        }
    },

    methods: {
        open() {
            this.show = true;
        },

        hide() {
            this.show = false;
        },

        openRow(c) {
            this.stack = [...this.stack, c]; // push
        },

        closeRow(c) {
            if (this.stack && this.stack.length) {
                this.stack.splice(this.stack.length - 1, 1);
            } else {
                this.hide()
            }
        },

        select(c) {
            if (this.onSelect) {
                this.onSelect(c);
            }
        },

        /**
         * 初始化组建
         */
        async init() {
            // 加载所有种类
            this.loading = true;

            try {
                const categories = await this.loadCategories();
                this.all = categories;
                this.error = null;
            } catch (e) {
                this.error = e;
                throw e;
            } finally {
                this.loading = false;
            }

            // 顶部默认显示第一层类别
            this.topCategories = _.clone(this.all);
            this.displayCategories = [_.clone(this.all)];

            if (!this.categories || !this.categories.length) {
                return;
            }

            // 默认选中第一个分类
            const selectedCategory = this.categories[0];
            this.selectCategory(selectedCategory);
        },

        /**
         * 加载类别树
         */
        async loadCategories() {
            const result = await api.categoryData();
            if (result.code !== 200) {
                throw result.msg;
            }

            const list = result.data;
            if (!list || !list.length) {
                return [];
            }

            const trees = this.buildCategoryTrees(list)
            return trees
        },

        /**
         * 构建树
         */
        buildCategoryTrees(list) {
            const map = new Map();

            list.forEach(ele => {
                map.set(ele._id, {
                    ...ele,
                    children: [],
                });
            });

            const result = [];
            map.forEach((v) => {
                if (v.parentId) {
                    map.get(v.parentId).children.push(v);
                } else {
                    result.push(v);
                }
            });

            this.categoriesMap = map;

            return result;
        },
    },

    computed: {
        head: function () {
            return {
                category: "返回上一级",
            };
        },

        displayList: function () {
            if (!this.stack || !this.stack.length) {
                return this.all;
            }

            return this.stack[this.stack.length - 1].children;
        }
    },
}
</script>

<style lang="scss" scoped>
.pop-over {
    width: 100%;
    max-width: 750px;
    height: 100%;
    position: fixed;
    overflow-y: scroll;
    overflow-x: hidden;
    background: $bg01;
    padding: 0 30px;
    top: 0;
    z-index: 999999;
    box-sizing: border-box;
}
</style>
